module.exports = __webpack_public_path__ + "assets/notification_points.da953b6c.svg";